import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguagesModule } from 'app/layout/common/languages/languages.module';
import { TranslocoModule } from '@ngneat/transloco';
import { LanguageComponent } from './language-page.component';
@NgModule({
  declarations: [LanguageComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    LanguagesModule
  ],
  exports: [LanguageComponent]
})
export class LanguagePageModule { }
